export default __webpack_public_path__ + "static/media/AI Concierge.970ebfa8.svg";